import currency from './currency.filter';

export default currency;
